import React, { memo } from 'react';
import '../../../Common/Filters/Filters.css';
import { getMonthsByYear } from '../../../Common/Util/getMonthsByYear';
import { getYearsDescending } from '../../../Common/Util/getYearsDescending';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import useServiceTypes from './hooks/useServiceTypes';
import useHouseHoldStatus from './hooks/useHouseHoldStatus';
import useImmunobiologicals from './hooks/useImmunobiologicals';
import useImmunobiologicalsDoses from './hooks/useImmunobiologicalsDoses';
import useProcedures from './hooks/useProcedures';
import useCbo from './hooks/useCbo';
import useHealthUnits from './hooks/useHealthUnits';

export const years = getYearsDescending();

export const filtersInitialState = {
    cidade: {
        value: '',
        label: 'Todas',
        governance_room_client_city_id: null,
        governance_room_geo_city_id: null
    },
    unidade: {
        value: '',
        label: 'Todos'
    },
    ano: {
        value: new Date().getFullYear().toString(),
        label: new Date().getFullYear().toString()
    },
    competencia: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    register_type_results: {
        value: 2,
        label: 'Atualizações'
    },
    register_type_registers: {
        value: 1,
        label: 'Cadastro Domiciliar e Territorial'
    },
    service_type_stratified: {
        value: 2,
        label: 'Atendimento Individual'
    },
    service_type_professionals: {
        value: '',
        label: 'Todos'
    },
    household_status: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    immunobiological: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    immunobiological_dose: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    procedures: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    procedure_group: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    procedure_subgroup: [
        {
            value: '',
            label: 'Todos'
        }
    ],
    cbo: [
        {
            value: '',
            label: 'Todos'
        }
    ]
};

const Filters = ({
    className = '',
    showRegisterTypeResults = false,
    showRegisterTypeRegisters = false,
    showServiceTypesStratified = false,
    showServiceTypesProfessionals = false,
    showHouseholdStatus = false,
    showImmunobiologicals = false,
    showImmunobiologicalsDoses = false,
    showProcedureGroup = false,
    showProcedureSubgroup = false,
    showProcedures = false,
    showCbo = false,
    showLocation = true
}) => {
    const { data: serviceTypes } = useServiceTypes();
    const { data: householdStatus } = useHouseHoldStatus();
    const { data: immunobiologicals } = useImmunobiologicals();
    const { data: immunobiologicalsDoses } = useImmunobiologicalsDoses();
    const { data: procedures } = useProcedures();
    const { data: cbo } = useCbo();
    const { handleChangeFilters, filters } = useFiltersContext();
    const { data } = useHealthUnits(
        filters?.cidade?.governance_room_geo_city_id
    );

    const onFilterChange = (name, value) => {
        let newValue = value;
        if (
            name === 'household_status' ||
            name === 'immunobiological' ||
            name === 'immunobiological_dose' ||
            name === 'procedures' ||
            name === 'procedure_group' ||
            name === 'procedure_subgroup' ||
            name === 'cbo' ||
            name === 'competencia'
        ) {
            const values = value.map((item) => item.value);

            if (values.includes('') && values.length > 1) {
                newValue = value.filter((item) => item.value !== '');
            }

            if (values.length === 0) {
                newValue = [{ value: '', label: 'Todos' }];
            }
        }
        const newFilters = { ...filters, [name]: newValue };
        handleChangeFilters(newFilters);
    };

    const locations = data || [];

    const serviceTypesOptions = serviceTypes || [];

    const houseHoldStatusOptions = householdStatus || [];

    const immunobiologicalsOptions = immunobiologicals || [];

    const immunobiologicalsDosesOptions = immunobiologicalsDoses || [];

    const proceduresOptions = procedures?.procedures || [];

    const proceduresGroupsOptions = procedures?.groups || [];

    const proceduresSubgroupsOptions = procedures?.subGroups || [];

    const cboOptions = cbo || [];

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            {showLocation && (
                <MultipleSelect
                    label="Unidade de Saúde"
                    options={[{ value: '', label: 'Todos' }, ...locations]}
                    onChange={onFilterChange}
                    name="unidade"
                    className="select-unidade-dashboards"
                    defaultValue={filters.unidade}
                />
            )}

            {showServiceTypesStratified && (
                <MultipleSelect
                    label="Tipo de Atendimento"
                    options={serviceTypesOptions}
                    onChange={onFilterChange}
                    name="service_type_stratified"
                    className="select-unidade-dashboards"
                    defaultValue={filters.service_type_stratified}
                />
            )}
            {showServiceTypesProfessionals && (
                <MultipleSelect
                    label="Tipo de Atendimento"
                    options={[
                        { value: '', label: 'Todos' },
                        ...serviceTypesOptions
                    ]}
                    onChange={onFilterChange}
                    name="service_type_professionals"
                    className="select-unidade-dashboards"
                    defaultValue={filters.service_type_professionals}
                />
            )}
            {showHouseholdStatus && (
                <MultipleSelect
                    label="Característica do Paciente Acompanhado"
                    options={[...houseHoldStatusOptions]}
                    onChange={onFilterChange}
                    name="household_status"
                    className="select-unidade-dashboards"
                    defaultValue={filters.household_status}
                    isMulti
                />
            )}
            {showRegisterTypeResults && (
                <MultipleSelect
                    label="Tipo de Registro"
                    options={[
                        { value: 2, label: 'Atualizações' },
                        { value: 1, label: 'Novos Cadastros' },
                        { value: 0, label: 'Recusas' }
                    ]}
                    onChange={onFilterChange}
                    name="register_type_results"
                    defaultValue={filters.register_type_results}
                    className="select-unidade-dashboards"
                />
            )}
            {showRegisterTypeRegisters && (
                <MultipleSelect
                    label="Tipo de Registro"
                    options={[
                        {
                            value: 1,
                            label: 'Cadastro Domiciliar e Territorial'
                        },
                        { value: 2, label: 'Cadastro Individual' }
                    ]}
                    onChange={onFilterChange}
                    name="register_type_registers"
                    defaultValue={filters.register_type_registers}
                    className="select-unidade-dashboards"
                />
            )}
            {showImmunobiologicals && (
                <MultipleSelect
                    label="Tipo de Imunobiológico"
                    options={[...immunobiologicalsOptions]}
                    onChange={onFilterChange}
                    name="immunobiological"
                    defaultValue={filters.immunobiological}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}
            {showImmunobiologicalsDoses && (
                <MultipleSelect
                    label="Dose do Imunobiológico"
                    options={[...immunobiologicalsDosesOptions]}
                    onChange={onFilterChange}
                    name="immunobiological_dose"
                    defaultValue={filters.immunobiological_dose}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}

            {showProcedures && (
                <MultipleSelect
                    label="Procedimento"
                    options={[...proceduresOptions]}
                    onChange={onFilterChange}
                    name="procedures"
                    defaultValue={filters.procedures}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}
            {showProcedureGroup && (
                <MultipleSelect
                    label="Grupo"
                    options={[...proceduresGroupsOptions]}
                    onChange={onFilterChange}
                    name="procedure_group"
                    defaultValue={filters.procedure_group}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}
            {showProcedureSubgroup && (
                <MultipleSelect
                    label="Subgrupo"
                    options={[...proceduresSubgroupsOptions]}
                    onChange={onFilterChange}
                    name="procedure_subgroup"
                    defaultValue={filters.procedure_subgroup}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}
            {showCbo && (
                <MultipleSelect
                    label="CBO"
                    options={[...cboOptions]}
                    onChange={onFilterChange}
                    name="cbo"
                    defaultValue={filters.cbo}
                    className="select-unidade-dashboards"
                    isMulti
                />
            )}
            <MultipleSelect
                label="Ano"
                options={[
                    ...years
                        .map((year) => ({ value: year, label: year }))
                        .reverse()
                ]}
                onChange={onFilterChange}
                name="ano"
                defaultValue={filters.ano}
                className="select-ano-dashboards"
            />

            <MultipleSelect
                label="Competência"
                options={[
                    ...getMonthsByYear(filters.ano.value).map(
                        (month, index) => ({
                            value: `${index + 1}`.padStart(2, '0'),
                            label: month
                        })
                    )
                ]}
                onChange={onFilterChange}
                name="competencia"
                defaultValue={filters.competencia}
                className="select-competencia-dashboards"
                isMulti
            />
        </div>
    );
};

export default memo(Filters);
